import React from "react";
import { X } from "lucide-react";

const CancelOrderModal = ({
  showCancelModal,
  cancelReason,
  setCancelReason,
  setShowCancelModal,
  cancellationReasons,
  handleCancelConfirm,
}) => {
  if (!showCancelModal) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl">
        <div className="mb-4 flex items-center justify-between">
          <div>
            <h3 className="text-lg font-bold text-slate-900">Cancel Order</h3>
            <p className="mt-1 text-sm text-slate-500">
              Please select a cancellation reason.
            </p>
          </div>

          <button
            type="button"
            onClick={() => {
              setShowCancelModal(false);
              setCancelReason("");
            }}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-600 hover:bg-slate-200"
          >
            <X size={18} />
          </button>
        </div>

        <div className="mb-5">
          <label className="mb-2 block text-sm font-semibold text-slate-700">
            Cancellation Reason
          </label>

          <select
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
            className="w-full rounded-lg border border-slate-300 bg-white px-3 py-3 text-sm text-slate-700 outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100"
          >
            <option value="">Select reason</option>

            {cancellationReasons.map((reason) => (
              <option key={reason} value={reason}>
                {reason}
              </option>
            ))}
          </select>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <button
            type="button"
            onClick={() => {
              setShowCancelModal(false);
              setCancelReason("");
            }}
            className="rounded-lg border border-slate-200 bg-white py-3 font-bold text-slate-700 hover:bg-slate-50"
          >
            Keep Order
          </button>

          <button
            type="button"
            disabled={!cancelReason}
            onClick={handleCancelConfirm}
            className={`rounded-lg py-3 font-bold text-white transition ${
              cancelReason
                ? "bg-red-600 hover:bg-red-700"
                : "cursor-not-allowed bg-red-300"
            }`}
          >
            Confirm Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelOrderModal;